"use client";

import Image from "next/image";

export function ExperienceGallery() {
  const experiences = [
    {
      title: "Ministerial Roundtables",
      description:
        "Engage directly with education ministers and policymakers shaping Africa's future",
      image: "/ministers.jpeg",
    },
    {
      title: "Student Pitch Competition",
      description:
        "Watch 2,000+ talented students compete students compete for funding and showcase innovative solutions",
      image: "/student-pitch.png",
    },
    {
      title: "EdTech Showcase",
      description:
        "Explore cutting-edge education technology from Africa's leading innovators",
      image: "/shake-stand.jpeg",
    },
    {
      title: "Networking & Deal-Making",
      description:
        "Connect with investors, universities, and partners in exclusive networking sessions",
      image: "/2podiums-2ladies-shake-hands.jpg",
    },
  ];

  return (
    <section className="bg-muted py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-16 max-w-3xl text-center">
          <h2 className="mb-4 text-3xl font-bold text-foreground md:text-4xl lg:text-5xl text-balance">
            What to Expect
          </h2>
          <p className="text-lg text-muted-foreground text-pretty">
            Immerse yourself in two days of transformative experiences,
            connections, and opportunities
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {experiences.map((experience, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl bg-card transition-all hover:shadow-xl hover:-translate-y-1 duration-300 animate-in fade-in slide-in-from-bottom-6"
              style={{ animationDelay: `${index * 300}ms` }}
            >
              <div className="relative h-64 overflow-hidden">
                <Image
                  src={experience.image || "/placeholder.svg"}
                  alt={experience.title}
                  fill
                  className="object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="mb-2 text-xl font-bold text-card-foreground text-balance">
                  {experience.title}
                </h3>
                <p className="text-sm text-muted-foreground text-pretty">
                  {experience.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
